import { Text, VStack } from "@chakra-ui/react";
import PlayingCardBack from "./PlayingCardBack";

export default function PlayingCard({ rank, suit, isVisible }) {
  if (!isVisible) {
    return <PlayingCardBack />;
  } else {
    return (
      <VStack
        w="100px"
        h="168px"
        bg="#E6A9EB"
        borderRadius="lg"
        flexDirection="column"
        justifyContent="space-between"
        border="1px solid #E43D4D44"
      >
        <Text
          fontSize="3xl"
          fontWeight="semibold"
          color="#E43D4D"
          px="8px"
          w="100%"
        >
          {rank}
        </Text>
        <Text fontSize="4xl" color="#E43D4D">
          {suit}
        </Text>
        <Text
          fontSize="3xl"
          fontWeight="semibold"
          color="#E43D4D"
          px="8px"
          w="100%"
          transform="rotate(180deg)"
        >
          {rank}
        </Text>
      </VStack>
    );
  }
}
